import React from "react"


const HeadingContent = ({ className, bodyStyle, hideGradient=false, heading, children }) => {
    return (
        <div className={"flex column " + className ? className : ""}>
            {
                heading && <> <span className="f32 c1 bold">{heading}</span>
                   {!hideGradient && <div className="headingGradient"></div>} </>}
            <div className="headingContentContainer" style={bodyStyle}>{children}</div>
        </div>
    )
}

export default HeadingContent;